import Vue from 'vue'
import Vuex from 'vuex'
import pages from './modules/pages.js'
import cache from './modules/cache.js'
import account from './modules/account.js';
import remark from './modules/remark.js';

Vue.use(Vuex)

//初始化时用sessionStorage.getItem('token') 这样页面刷新无需重新登录
const state = {
  fullscreenLoading:false,//全屏加载
  loadingTxt:"",//加载时显示的文字
  isLoading:false,//局部加载
  isShow:false,//loading加载是否显示(全屏)
  getAllPage:{//不分页的数据请求
  	"page":1,
  	"pageSize":1000
  },
  listFrom:{//分页数据
    total:0,//总条数
    pages:0//总页数
  },
  fromData:{
    "page": 1,
    "pageSize": 5,
    "searchCriteria":{//查询的附加条件
    },
  }
};

//获取属性的状态
const getters = {
  //isLogin: state => state.isLogin
};

//设置属性状态
const mutations = {
  //保存登录状态
  setUser(state, flag){
    state.isLogin = flag;
    sessionStorage.setItem('isLogin',flag);
  },
  //设置局部加载
  setIsLoading(state,flag){
    state.isLoading = flag;
  }
};

//应用mutations
const actions = {
  setIsLoading({commit},flag){
    commit("setIsLoading",flag);
  },
};

//模块
const modules = {
  pages,cache,account,remark
};
export default new Vuex.Store({
	state,
	mutations,
	actions,
  modules
})
